import { columnType } from 'components/table/types';
import { SignerDashboardTableType } from 'constants/requests.constants';
import { tableColumns } from './tables.types';
import _ from 'lodash';
import { Box, Tooltip } from '@mui/material';
import { formatDateTime } from 'constants/global.constants';

import { depositType } from 'constants/balance.constants';

export const tableData = (data: Record<string, any>[], t: any) => {
	if (!data) {
		return [];
	}
	const emptyValue = '';
	return data.map((item) => {
		let firstApprover;
		if (item?.documentedOnHyper === true) {
			firstApprover = t('boSigner.firstApprover.digitalDeposit');
		} else {
			firstApprover = item?.createdByBoUser
				? `${item?.createdByBoUser?.firstName || emptyValue} ${item?.createdByBoUser?.lastName || emptyValue} `
				: item?.boApprovedByUser
				? `${item?.boApprovedByUser?.firstName || emptyValue} ${item?.boApprovedByUser?.lastName || emptyValue}`
				: `${item?.boADeclinedByUser?.firstName || emptyValue} ${
						item?.boADeclinedByUser?.lastName || emptyValue
				  }`;
		}
		return {
			...item,
			boApprovedByUser: firstApprover,
			boApprovedBySecondUser: item?.documentedByBoUser
				? `${item.documentedByBoUser.firstName || emptyValue} ${
						item.documentedByBoUser.lastName || emptyValue
				  } `
				: `${item?.boApprovedBySecondarySignerUser?.firstName || emptyValue} ${
						item?.boApprovedBySecondarySignerUser?.lastName || emptyValue
				  } `,
			hebrewName: item?.company?.hebrewName,
			transferOrigin:
				item?.depositType === depositType.Digital
					? t('transferType.digitalTopping')
					: t(`transferType.${_.camelCase(item?.type)}`),
			amount: `${item?.amount?.toLocaleString()} ${item?.currency?.symbol}`,
			openAccountNumber: item?.company?.accountId,
			status: t(`status.${_.camelCase(item?.status)}`),
			boApprovalDate: formatDateTime(
				item?.feezbackUpdatedAt
					? item?.feezbackUpdatedAt
					: item?.boApprovalDate
					? item?.boApprovalDate
					: item?.boDeclinedDate
			),
			boSecondarySignerApprovalDate: item?.hyperDocumentedAt
				? formatDateTime(item.hyperDocumentedAt)
				: formatDateTime(item.boSecondarySignerApprovalDate),
		};
	});
};

export const buildColumns = (type: SignerDashboardTableType, t: any, sortableColumns?: string[]): columnType[] => {
	const columns: columnType[] = [];

	if (_.has(tableColumns, type)) {
		_.keys(tableColumns[type]).map((element) => {
			let customValueHandle = {};
			if (element === 'paymentType') {
				customValueHandle = {
					customValueHandle: (value: any, row: Record<string, any>) => {
						return (
							<Box position={'relative'}>
								{row?.fee && (
									<Tooltip title={row.fee}>
										<img
											style={{
												position: 'absolute',
												left: '100%',
											}}
											src="/icons/swift.svg"
										/>
									</Tooltip>
								)}
								<Box>{value}</Box>
							</Box>
						);
					},
				};
			}
			const props: columnType = {
				fieldId: 'id',
				name: element,
				title: t('page.dashboard.boSigner.requests.field.' + element),
				type: tableColumns[type][element],
				sortable: sortableColumns ? sortableColumns.includes(element) : true,
				...customValueHandle,
			};
			columns.push(props);
		});
	}
	return columns;
};
